<template>
	<div>

		<v-stepper v-model="sección" v-if="opción">

			<v-stepper-header>
				<template v-for="(s, i) in opción.secciones">

					<v-stepper-step
						:key="`${i+1}-step`"
						:complete="sección > i+1"
						:step="i+1"
						:rules="[() => !validacionesDeSecciones[i] || !validacionesDeSecciones[i].e]"
						editable
					>
						{{ s.título }}
					</v-stepper-step>

					<v-divider
						v-if="i+1 < opción.secciones.length"
						:key="i+1"
					></v-divider>

				</template>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content
					v-for="(s, i) in opción.secciones"
					:key="`${i+1}-content`"
					:step="i+1"
				>

					<v-alert
						v-if="validacionesDeSecciones[i] && validacionesDeSecciones[i].v"
						dense
						border="left"
						type="warning"
					>
						{{ validacionesDeSecciones[i].v }}
					</v-alert>

					<v-card v-for="(c, j) in s.componentes" :key="j" class="ma-5" style="border: 1px solid silver">

						<div v-if="c.requerido && c.selección" style="display:inline-block">
							<v-switch v-model="c.selección" color="success" class="pl-4" :disabled="true" style="display:inline-block"></v-switch>
							<h3 class="pl-2 headline" style="display:inline-block; color:rgba(0, 0, 0, 0.54)">{{ c.nombre }}</h3>
						</div>
						<v-switch v-else v-model="c.selección" color="success" class="pl-4">
							<template v-slot:label>
								<h3 class="pl-2 headline">{{ c.nombre }}</h3>
							</template>
						</v-switch>

						<v-alert
							v-if="validacionesDeSecciones[i] && validacionesDeSecciones[i].componentes[j].v"
							dense
							border="left"
							type="warning"
						>
							{{ validacionesDeSecciones[i].componentes[j].v }}
						</v-alert>

						<v-card :disabled="!c.selección" :elevation="0">
							<v-card-text class="pt-0">
								<p class="subtitle-1">{{ c.descripción }}</p>
								<p v-if="c.personalizaciones && c.personalizaciones.length > 0" class="caption">
									Puede personalizar este componente eligiendo a su gusto las siguientes opciones:
								</p>
								<v-divider></v-divider>
								<div v-for="(p, k) in c.personalizaciones" :key="k">
									<v-checkbox 
										v-if="p.tipo === 'SELECCIÓN_SIMPLE'" 
										v-model="p.configuración.selección" 
										:label="p.configuración.descripción"
										color="primary"
									></v-checkbox>
									<div v-if="p.tipo === 'OPCIONES_MÚLTIPLES'">
										<p class="mt-4">{{ p.configuración.descripción }}</p>
										<v-radio-group v-model="p.configuración.selección">
											<v-radio
												v-for="(o, l) in p.configuración.opciones"
												:key="l"
												:label="o.descripción"
												:value="l"
												color="primary"
											></v-radio>
										</v-radio-group>
									</div>
									<v-divider v-if="k+1 < c.personalizaciones.length"></v-divider>
								</div>
							</v-card-text>
						</v-card>

					</v-card>

					<v-btn
						v-if="sección > 1"
						color="primary"
						class="mt-4 mx-2"
						@click="sección = i"
					>
						Regresar
					</v-btn>

					<v-btn
						v-if="sección < opción.secciones.length"
						color="primary"
						class="mt-4 mx-2"
						@click="sección = i+2"
					>
						Continuar
					</v-btn>

					<v-btn
						v-else
						color="primary"
						class="mt-4 mx-2"
						@click="finalizarSecciones"
					>
						Continuar
					</v-btn>

				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>

		<v-snackbar
      v-model="avisoErroresDeSelección"
      bottom
      color="error"
    >
      No ha hecho una selección adecuada. Revise los títulos en rojo y con advertencias.
      <v-btn dark text @click="avisoErroresDeSelección = false">Cerrar</v-btn>
    </v-snackbar>

	</div>
</template>


<script>
import { númeroEnLetrasYTextoConcordante } from '../../../../cliente-comun/utilidades'

export default {
	name: 'OpcionPersonalizar',
	data: () => ({
		sección: 1,
		validacionesDeSecciones: [],
		hayErroresDeSelección: false,
		avisoErroresDeSelección: false,
	}),
	props: ['opción'],
	watch: {
		'opción.secciones': {
			handler: function(sccns) {
				this.hayErroresDeSelección = false
				for (let i in sccns) {
					let sección = { e: false, v: '', componentes: [] }
					let slccnds = sccns[i].componentes.filter(com => com.selección).length
					if (slccnds < sccns[i].componentes_mínimos) {
						let nt = númeroEnLetrasYTextoConcordante(sccns[i].componentes_mínimos, 'un', 'componente', 'componentes')
						if (sccns[i].componentes_mínimos === sccns[i].componentes_máximos) {
							sección.v = `Debe elegir ${nt.n} ${nt.t}.`
						} else {
							sección.v = `Debe elegir al menos ${nt.n} ${nt.t}.`
						}
					} else if (slccnds > sccns[i].componentes_máximos) {
						let nt = númeroEnLetrasYTextoConcordante(sccns[i].componentes_máximos, 'un', 'componente', 'componentes')
						sección.v = `No puede elegir más de ${nt.n} ${nt.t}.`
					}

					for (let c of sccns[i].componentes) {
						let cv = ''
						if (c.requerido && !c.selección) {
							cv = 'Este componente es requerido.' // Esto no debería ocurrir nunca
						}
						sección.componentes.push({ v: cv })
					}

					sección.e = !!sección.v || sección.componentes.filter(com => com.v).length > 0

					this.hayErroresDeSelección = this.hayErroresDeSelección || sección.e
					this.$set(this.validacionesDeSecciones, i, sección)
				}
			},
			deep: true
		}
	},
	methods: {
		finalizarSecciones: function() {
			if (this.hayErroresDeSelección) {
				this.avisoErroresDeSelección = true
				return
			}

			this.avisoErroresDeSelección = false
			this.$emit('concluir', true)
		}
	}
}
</script>